module.exports = __webpack_public_path__ + "img/YKKAP1.5f255b7b.jpg";